import type { ReactNode } from 'react'
import { StorefrontProductAttributesSection, type StorefrontProductFieldRow } from '@emporion/ui'
import type { ProductCustomFieldRow, ProductCustomFieldSection } from './helpers'
import { ProductFieldValue } from './ProductFieldValue'
import type { CatalogProduct } from '../../types'

type Props = {
  title: string
  rows: ProductCustomFieldRow[]
  description?: string
  columns?: 1 | 2 | 3
  layoutType?: ProductCustomFieldSection['layoutType']
  renderValue?: (row: ProductCustomFieldRow) => ReactNode
  productData?: CatalogProduct | null
  locale?: string
}

const ProductAttributesSection = ({
  title,
  rows,
  description,
  renderValue,
  productData,
  locale,
}: Props) => {
  if (rows.length === 0) return null

  return (
    <StorefrontProductAttributesSection
      title={title}
      rows={rows}
      description={description}
      renderValue={(row) => {
        const productRow = row as ProductCustomFieldRow
        return renderValue
          ? renderValue(productRow)
          : <ProductFieldValue row={productRow} productData={productData} locale={locale} />
      }}
    />
  )
}

export default ProductAttributesSection
